import { Text, Title, Center } from "@mantine/core";

const HeroFront = () => {
  const frontText = `Web developer`;
  const frontText2 = `Always optimistic and hassle-free.`;
  const frontText3 = `I love to work in international environment.`;

  return (
    <>
      <Text
        className="onlyMobile contentContainer"
        component="span"
        align="center"
        size="xl"
        color="white"
        weight={250}
      >
        <Center>
          {frontText} <br></br>
          <br></br>
          {frontText2}
          <br></br>
          {frontText3}
        </Center>
      </Text>
      <Text
        className="splineHeroHeaderText onlyDesktop"
        component="span"
        align="center"
        variant="gradient"
        gradient={{ from: "white", to: "black", deg: 90 }}
        size="xl"
        weight={250}
      >
        <Center>
          <p>
            Over a year of experience as a Full Stack Developer at Comarch,
            proficient in Java and Angular.<br></br>.<br></br> Co-founder of{" "}
            <a className="linkGowedding" href="https://www.gowedding.online/">
              GoWedding.Online
            </a>
            , an online wedding solutions startup using Next.js.{" "}
          </p>
        </Center>
      </Text>
    </>
  );
};

export default HeroFront;
